import { CloudIcon } from "../../../../../shared/icons/CloudIcon";
import { EyeIcon } from "../../../../../shared/icons/EyeIcon";
import { InboxIcon } from "../../../../../shared/icons/InboxIcon";
import { LocalDatabaseIcon } from "../../../../../shared/icons/LocalDatabaseIcon";
import { LockIcon } from "../../../../../shared/icons/LockIcon";
import { ShareIcon } from "../../../../../shared/icons/ShareIcon";
import { TItem } from "../../../types";
import styles from "./styles.module.css";

interface Props {
  type: TItem;
}

export const SidebarItemIcon = ({ type }: Props) => {
  switch (type) {
    case "local_base": {
      return (
        <LocalDatabaseIcon className={styles["icon"]} width={16} height={16} />
      );
    }
    case "openai_base": {
      return <CloudIcon className={styles["icon"]} width={16} height={16} />;
    }
    case "received_object": {
      return (
        <InboxIcon className={styles["received-icon"]} width={14} height={14} />
      );
    }
    case "shared_object": {
      return (
        <ShareIcon className={styles["share-icon"]} width={12} height={12} />
      );
    }
    case "read_only": {
      return (
        <LockIcon className={styles["readonly-icon"]} width={14} height={14} />
      );
    }
    default: {
      return;
    }
  }
};
